import { useEffect, useState } from 'react';
import { db, storage } from '../../../firebase';
import { collection, getDocs } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import './Teamcarousel.css';

const MemberCard = ({ member }) => {
    const [imageUrl, setImageUrl] = useState(null);

    useEffect(() => {
        const imageRef = ref(storage, `profile_pictures/${member.id}.jpg`);
        getDownloadURL(imageRef)
            .then(setImageUrl)
            .catch(() => {});
    }, [member.id]);

    return (
        <div className="member-card">
            <div className="member-image-wrapper">
                {imageUrl
                    ? <img src={imageUrl} alt={member.name} />
                    : <span className="member-avatar-fallback">&#128100;</span>
                }
            </div>
            <h3 className="member-name">{member.name}</h3>
            <p className="member-position">{member.position}</p>
        </div>
    );
};

const Teamcarousel = () => {
    const [members, setMembers] = useState([]);

    useEffect(() => {
        getDocs(collection(db, "members")).then((snapshot) => {
            const data = [];
            snapshot.forEach((doc) => data.push({ id: doc.id, ...doc.data() }));
            setMembers(data);
        });
    }, []);

    if (members.length === 0) {
        return <p className="team-loading">Team wird geladen…</p>;
    }

    return (
        <div className="team-scroll-outer">
            <div className="team-scroll-track">
                {members.map((member) => (
                    <MemberCard key={member.id} member={member} />
                ))}
            </div>
        </div>
    );
};

export default Teamcarousel;
